var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 19V10.5C4 9.24097 4.5928 8.05538 5.6 7.29997L10.8 3.39998C11.5111 2.86668 12.4889 2.86668 13.2 3.39998L18.4 7.29997C19.4073 8.05538 20 9.24097 20 10.5001V19.0001C20 20.1047 19.1046 21.0001 18 21.0001H15.7C15.1477 21.0001 14.7 20.5523 14.7 20.0001V16.5001C14.7 14.9607 13.4119 13.7223 11.8547 13.8039C10.3947 13.8804 9.3 15.1909 9.3 16.6529V20.0001C9.3 20.5523 8.8523 21.0001 8.3 21.0001H6C4.8954 21.0001 4 20.1046 4 19Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.00bb9bb1115c443ace39cf3d1a817b91.svg";
export { ForwardRef as ReactComponent };